import { Button } from '@arionbanki/arionui';
import type { CreditCheckProps } from './CreditCheck';
import { CreditCheckButtonText } from './CreditCheckButtonText';

export function CreditCheckForm(props: CreditCheckProps) {
	const { data, goToNextPage, t } = props;

	if (data) {
		return (
			<div className="my-4">
				<strong className="text-secondary">{t('derivatives', 'products')}</strong>
				<p>
					<small>{t('derivatives_disclaimer', 'products')}</small>
				</p>
				<Button disabled={data.externalCreditCheck} mode="error" onClick={goToNextPage}>
					{CreditCheckButtonText(data, t)}
				</Button>
			</div>
		);
	}

	return <span>{t('no_products', 'products')}</span>;
}
